import {Injectable} from '@angular/core';
import {LoggerService} from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class LocalLoggerService implements LoggerService {
  warn(message, context) {
    console.warn(message, context);
  }

  error(message, context) {
    console.error(message, context);
  }
}
